import React from "react";
import { useSelector } from "react-redux";
import { guidelines, expect } from "../SampleData";
import { ReactComponent as AlertLogo } from "../../../assets/icons/AlertLogo.svg";
import SvgMapper from "../../features/common/SvgMapper";

const InterviewDetails = () => {
  const { activeInterview } = useSelector((state) => state.studentpage);

  const difficultyStyles = {
    beginner: "text-green-700 bg-green-50",
    intermediate: "text-yellow-600 bg-yellow-50",
    advanced: "text-red-700 bg-red-50",
  };

  const formatDifficulty = (difficulty) => {
    if (!difficulty) return "N/A";
    return difficulty.charAt(0).toUpperCase() + difficulty.slice(1).toLowerCase();
  };

  const formatDuration = (duration) => {
    if (!duration) return "N/A";
    return `${duration} minutes`;
  };

  const interviewType = activeInterview?.interview_name || activeInterview?.interview_type || "N/A";

  const difficulty = activeInterview?.difficulty || "";
  const duration = activeInterview?.duration || "";

  return (
    <div className="space-x-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Interview Details
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center p-4 rounded-lg bg-gray-50">
            <span className="text-gray-600">Interview Type</span>
            <span className="font-semibold text-blue-900">
              {interviewType}
            </span>
          </div>

          <div className="flex justify-between items-center p-4 rounded-lg bg-gray-50">
            <span className="text-gray-600">Difficulty Level</span>
            <span
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                difficultyStyles[difficulty?.toLowerCase()] || difficultyStyles.beginner
              }`}
            >
              {formatDifficulty(difficulty)}
            </span>
          </div>

          <div className="flex justify-between items-center p-4 rounded-lg bg-gray-50">
            <span className="text-gray-600">Duration</span>
            <span className="font-medium text-gray-900">
              {formatDuration(duration)}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 rounded-lg p-6 mt-4">
        <h4 className="font-medium text-blue-900 mb-3 flex items-center">
          <AlertLogo className="w-5 h-5 mr-2" />
          Interview Guidelines
        </h4>
        <ul className="text-sm text-blue-800 space-y-2">
          {guidelines.map((it, idx) => (
            <li key={idx} className="flex items-start space-x-2">
              {SvgMapper.checkCircle(
                "w-4 h-4 mt-0.5 flex-shrink-0 text-blue-600"
              )}
              <span>{it}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-yellow-50 rounded-lg p-6 mt-4">
        <h4 className="font-medium text-yellow-900 mb-3">What to Expect</h4>
        <div className="text-sm text-yellow-800 space-y-2">
          {expect.map((p, i) => (
            <p key={i}>• {p}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InterviewDetails;
